class utils {
  static px(value) {
    return `${value}px`;
  }

  static url(value) {
    if(!value || value === 'none') return 'none';
    return `url(${value})`;
  }

  static proc(value) {
    return `${value}%`;
  }
}

export default utils;
